import React, { useEffect, useState } from 'react'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import S from '../../pages/ListDam.module.css'

import Gadjet from '../../images/gadjet.svg'


import { ArrowBack, ArrowForward, DateRange, DateRangeRounded, Details, ImportantDevices, Key, KeyboardBackspace, Report, Sell, Sensors, SplitscreenOutlined } from '@mui/icons-material';
import { Pagination, Tab, Tabs } from '@mui/material';
import useHistory from '../CustomHooks/useHistory';
import HistoryCardList from '../cardThemes/historyCard';
import { useSelector } from 'react-redux';
import EmptyReturn from '../EmptyReturn';
import { useGlobalContext } from '../Context';
import StatusHistoryCompare from '../HistoryCompare/StatusHistoryCompare';
import MoveDetailStatus from '../MoveDetailStatus';
import { calculateDetails } from '../../pages/SingleDam';
const moment=require('moment-jalaali')
const imp=['🔴','🟡','🔵','🟣','🟢']
const StatusHistory = (props) => {
  const {currentCattle}=useSelector(state=>state.cattle)
  const [filterStatus,setFilterStatus]=useState([])
  const {detailStatusList}=useSelector(state=>state.p.admin)
  const {currentTheme}=useSelector(state=>state.p.admin)
  const [show,setShow]=useState(false)
  const [iindex,setIndex]=useState({index:0,currentSit:{}})
  const {openModalls,isOpenModal,openModalls2,isOpenModal2}=useGlobalContext()
  const flag='cattleStatus';
  const {total,page,handlePage,data,SData,setSdata,selectedDayRange, setSelectedDayRange,renderCustomInput,handleChange,value,setImportancelevel,importanceLevel,importanceList}=useHistory(flag)

  const gett=()=>{
    const d= calculateDetails(detailStatusList,null,iindex?.currentSit)
    setFilterStatus(d)
  }
  useEffect(()=>gett(),[iindex])
  return (
    <div>
      <div style={{display:'flex',justifyContent:'center'}}>
      <Tabs 
      
      value={value}
      onChange={handleChange}
      textColor="dark"
      indicatorColor="secondary"
      aria-label="secondary tabs example"
    >
      <Tab value="0" label="خوانده نشده" />
      <Tab value="1" label="خوانده شده " />
    </Tabs>
      </div>
      <div style={{display:'flex',justifyContent:'space-between',direction:'ltr'}}>
      <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
                       <select value={importanceLevel} onChange={(e)=>{setImportancelevel(e.target.value)}} style={{direction:'rtl',alignSelf:'end'}}   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`}  >
                       <option  value={'null'} >فیلتر بر اساس اهمیت</option>
    {importanceList.map((item,index)=>{
      return <option key={index} value={item.id} >{item?.description}</option>
    })} 
                            
                       
                    </select>
                       </div>
                       
        {!currentTheme&&<div className={S.TabForAllAnnimLICon}>
          
          
          <div className={S.AnimContentLI} style={{borderTopLeftRadius:'0px'}} data-aos='fade'>
          {data.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ArrowBack/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ArrowForward/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Details/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ImportantDevices/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  
                  
                 <th>
                 <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                 </th>
                 <th>
                 <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                 </th>
                 <th>
                 <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                 </th>
                 <th>
                  <div className='LogoFormT'><div><span>
                    <img style={{width:'20px',height:'20px'}} src={Gadjet}/>
                </span>
                    </div></div>
                  </th>
                  {value==0&&<th>
                  <div className='LogoFormT'><div><span>
                    <Report/>
                </span>
                    </div></div>
                  </th>}
                </tr>
                <tr>
                <th>
                    ردیف
                  </th>
                  <th>
                    مقدار گذشته
                  </th>
                  <th>مقدار حال</th>
                  <th>جزئیات وضعیت</th>
                  <th>سطح اهمیت</th>
                  <th>
                     تاریخ
                  </th>
                  <th>شماره سنسور</th>
                  <th>شماره گوش</th>
                  <th>شماره بدن</th>
                  <th>شماره گردنبند</th>
                  {value==0&&<th> مشاهده</th>}
                </tr>
              </thead>
              <tbody>
                {
                  data?.length&&data?.map((item,index)=>{
                    const {entryDate}=item;
                    const pbirth=moment(entryDate).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    <td>
                      {item?.oldCattleStatusTitle||item?.oldSensorStatusTitle}
                    </td>
                    <td style={{position:'relative'}}  ><div>{item?.newCattleStatusTitle||item?.newSensorStatusTitle}</div></td>
                    <td>
                    <div  onClick={()=>{
                      setIndex({index:index,currentSit:item});openModalls2()
                    }} className='btnCardDAm'>جزئیات</div>
                    </td>
                    <td>{imp[item?.newCattleStatusImportanceLevel]} {item?.newCattleStatusImportanceLevelTitle}</td>
                    <td>
                      {`${pbirth}`}
  
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleSensorDeviceCode?item?.cattleSensorDeviceCode:'---'}
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleEarTagNumber}
                    </td>
                    <td className={S.DetIc}>
                      {item?.cattleBodyNumber}
                    </td>
                    <td className={S.DetIc}>
                      {item?.necklaceNumber?item?.necklaceNumber:'---'}
                    </td>
                    {value==0&&<td>
                    <div  onClick={()=>{
                      setIndex({index:index,currentSit:item});setSdata(item);openModalls()
                    }} className='btnCardDAm'>متوجه شدم</div>
                    </td>}
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>
        </div>}
        {currentTheme&&<HistoryCardList setShow={setShow} show={show} gett={gett} iindex={iindex} setIndex={setIndex} filterStatus={filterStatus} flag={'status'} value={value} setSdata={setSdata} data1={filterStatus} seenFlag={true} data={data}/>}
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
            {isOpenModal&&<MoveDetailStatus  seenFlag={true} flag={"status"} SData={SData} data1={filterStatus}/>}
            {isOpenModal2&&<MoveDetailStatus seenFlag={false} flag={"status"} SData={SData} data1={filterStatus}/>}
    </div>
  )
}

export default StatusHistory
